import { orderBy, find } from "lodash";

import { getForecastAllocationProjects } from "src/allocation/util/allocationProject";
import {
  CONSTRAINT,
  FORECAST,
  PLANNER_CURRENT,
  PLANNER_REQUESTED,
  PLANNER_APPROVED,
} from "../../columnTypes";
import newColumn from "./newColumn";

const getAllocationProjectColumns = (allocationProjects, columnType) => {
  const sortedProjects = orderBy(
    getForecastAllocationProjects(allocationProjects),
    [(p) => p.startDate, (p) => p.allocationName?.toLowerCase()],
    ["asc", "asc"]
  );

  const columns = [];

  // Set allocation projects before the active one as static
  let isStatic = true;

  sortedProjects.forEach((allocationProject) => {
    const { isActive } = allocationProject;

    const column = newColumn({ allocationProject, columnType, isStatic });

    // Set isStatic to false after the current active allocation project
    if (isActive) {
      isStatic = false;
    }

    columns.push(column);
  });

  return columns;
};

export const getConstraintColumns = (allocationProjects) => {
  return getAllocationProjectColumns(allocationProjects, CONSTRAINT);
};

export const getForecastColumns = (allocationProjects) => {
  const allocationProjectColumns = getAllocationProjectColumns(
    allocationProjects,
    FORECAST
  );

  return allocationProjectColumns;
};

export const getPlannerColumns = (allocationProjects) => {
  const allocationProject = find(allocationProjects, (ap) => ap.isActive);
  if (allocationProject) {
    return [
      newColumn({ allocationProject, columnType: PLANNER_CURRENT }),
      newColumn({ allocationProject, columnType: PLANNER_REQUESTED }),
      newColumn({ allocationProject, columnType: PLANNER_APPROVED }),
    ];
  }
  return [];
};
